import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const DeleteTaskModal = ({ show, onClose, onConfirm, task, processing }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton={!processing}>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete task{" "}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={processing}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={processing}>
          {processing ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Deleting...
            </>
          ) : (
            "Delete"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteTaskModal;
